export const triggerAutocomplete = [
  { value: 0, label: 'On first client message' },
];

export default {};
